import type { BlogCandidate } from '../../../../services/blogCandidatesService';
import type { BlogRun } from '../../../../services/blogRunsService';

export type PipelineStage = {
  id: string;
  name?: string;
  order?: number;
  type?: string;
  depends_on?: string[];
  human_checkpoint?: boolean;
  prompt?: {
    model?: string;
    temperature?: number;
    max_tokens?: number;
    system_prompt?: string;
    thinking?: Record<string, unknown>;
    output_config?: Record<string, unknown>;
    template?: string;
    output_schema?: Record<string, unknown>;
  };
  output?: {
    type?: string;
    description?: string;
    key?: string;
    schema_example?: string;
  };
};

export type PipelineDoc = {
  pipeline?: {
    id?: string;
    name?: string;
    version?: string;
  };
  stages?: PipelineStage[];
};

export type ArticleStatus = 'Not Started' | 'In progress' | 'Published';

export type ArticleRow = {
  candidate: BlogCandidate;
  run?: BlogRun | null;
  status: ArticleStatus;
  currentStageId?: string | null;
};

export const STAGE_ORDER = [
  'stage_1a_keywords', 'stage_1b_semrush', 'stage_2a_serp_overview',
  'stage_2b_competitor_plan', 'stage_2c_competitor_extract', 'stage_2d_competitor_aggregate',
  'stage_2e_internal_links', 'stage_3a_brief',
  'stage_4a_research_enrichment', 'stage_4b_section_drafting', 'stage_4c_research_finalize',
  'stage_5_cta_placement', 'stage_6_seo_validation', 'stage_7_image_generation',
  'stage_7c_final_polish', 'stage_9_ai_queries', 'stage_8_wp_publish',
];
